import React from 'react';
import type IDealCellData from '@/creditflowresearch/ui/components/deals/DealListTable/cells/types';
import Tooltip from '@creditflowresearch/uilib/Tooltip';

import styles from '@/creditflowresearch/ui/components/deals/DealListTable/cells/Ticker/ticker.module.scss';
import dateListStyles from '@/creditflowresearch/ui/components/deals/DealListTable/cells/DateList/dateList.module.scss';

export const Ticker = ({ row }: { row: IDealCellData }) => {
  const { additionalIssuers = [], primaryIssuer } = row;
  const issuers = [primaryIssuer, ...additionalIssuers];
  const MAX_VISIBLE_ISSUERS = 2;

  const issuersWithTickers = issuers.filter((issuer) => issuer?.issuerTicker);

  if (!issuersWithTickers.length) {
    return <div>-</div>;
  }

  const visibleIssuers = issuersWithTickers.slice(0, MAX_VISIBLE_ISSUERS);
  const hiddenIssuers = issuersWithTickers.slice(MAX_VISIBLE_ISSUERS);

  const getTooltip = () => (
    hiddenIssuers.map((issuer) => (
      <div key={ issuer.id } className={ dateListStyles.tooltip }>
        <div>
          <span>{ issuer.issuerTicker }</span>
          <span>{ issuer.name }</span>
        </div>
      </div>
    ))
  );

  return (
    <div className={ styles.ticker }>
      { visibleIssuers.map((issuer) => (
        <Tooltip key={ issuer.id } content={ issuer.name }>
          { issuer.issuerTicker }
        </Tooltip>
      )) }

      { hiddenIssuers.length > 0 && (
        <Tooltip content={ getTooltip() }>
          <span>...</span>
        </Tooltip>
      ) }
    </div>
  );
};
